import { render } from "./SocialList.vue?vue&type=template&id=595b20f9&scoped=true&ts=true"
import script from "./SocialList.vue?vue&type=script&lang=ts"
export * from "./SocialList.vue?vue&type=script&lang=ts"

import "./SocialList.vue?vue&type=style&index=0&id=595b20f9&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595b20f9"]])

export default __exports__